import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './MenuItem.module.scss'
import Skeleton from 'shared/components/common/Skeleton/Skeleton.component'

const MenuItem = ({
  active,
  tip,
  route,
  icon,
  isSidebarMenuExpanded,
  isLoaded,
  onNavigate
}) => {

  if(!isLoaded) {
    return (
      <main className={classNames(
        styles.item,
        active && styles.itemActive,
        isSidebarMenuExpanded && styles.itemExpanded
      )}>
        { !isSidebarMenuExpanded &&
        <Skeleton width="22px" height="22px" />
        }
        { isSidebarMenuExpanded &&
        <div className={styles.itemDetails}>
          <Skeleton
            type="lighter"
            width="22px"
            height="22px"
          />
          <Skeleton
            type="light"
            width="80px"
            height="8px"
            style={{
              marginLeft: '16px'
            }}
          />
        </div>
        }
      </main>
    )
  }

  return (
    <main
      className={classNames(
        styles.item,
        styles.link,
        active && styles.itemActive,
        isSidebarMenuExpanded && styles.itemExpanded
      )}
      onClick={route ? onNavigate(route) : () => {}}
    >
      {
        (!isSidebarMenuExpanded) ?
          <img
            src={icon}
            className={styles.icon}
          /> :
          <div className={styles.itemDetails}>
            <img
              src={icon}
              className={classNames(styles.icon, styles.itemDetailIcon)}
            />
            <div
              className={classNames(
                styles.itemDetailLabel,
                styles.tipColor,
                isSidebarMenuExpanded && styles.itemDetailLabelExpanded
              )}
            >
              { tip }
            </div>
          </div>
      }
    </main>
  )
}

MenuItem.propTypes = {
  tip: PropTypes.string.isRequired,
  route: PropTypes.string,
  icon: PropTypes.string,
  active: PropTypes.bool.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  isSidebarMenuExpanded: PropTypes.bool.isRequired,
  onNavigate: PropTypes.func.isRequired
}

export default MenuItem
